import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useNavigate, useParams } from 'react-router-dom';
import useMountEffect from '@restart/hooks/useMountEffect';
import dayjs from 'dayjs';
import { Form, Divider, Input, Row, Button, Space, message, Statistic, Col, Flex, Select } from 'antd';

import styles from './new.module.scss';
import API from '../../helpers/API';

const cx = classNames.bind(styles);

const Page = () => {
  const { rid } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState();

  useMountEffect(() => {
    API.get(`/customers/${rid}`).then(({ success, data }) => {
      if (success) {
        setCustomer(data);
      }
    });
  });

  const handleChange = (e) => {
    setCustomer({
      ...customer,
      [e.target.name]: e.target.value,
    });
  };

  const doRemove = () => {
    if (!window.confirm('고객사를 삭제하시겠습니까?')) return;

    API.delete(`/customers/${rid}`).then(({ success }) => {
      if (success) {
        navigate('/customers');
      } else {
        message.error('삭제를 실패했습니다.');
      }
    });
  };

  const validation = () => {
    if (customer.name.trim() === '') {
      message.error('고객사명을 입력해 주세요.');
      return false;
    }

    return true;
  };

  const doSave = () => {
    if (!validation()) return;

    API.patch(`/customers/${rid}`, {
      name: customer.name,
      tel: customer.tel,
      address: customer.address,
      addressDetail: customer.addressDetail,
      status: customer.status,
      memo: customer.memo,
    }).then(({ success }) => {
      if (success) {
        navigate('/customers');
      } else {
        message.error('저장을 실패했습니다.');
      }
    });
  };

  if (customer === undefined) return;

  return (
    <div className={cx('container')}>
      <h1 className={cx('title')}>고객사 상세</h1>
      <div className={cx('contentWrapper')}>
        <Form layout="vertical">
          <Divider orientation="left" orientationMargin={0} className={cx('divider')}>
            기본정보
          </Divider>
          <Flex vertical style={{ maxWidth: 640 }}>
            <Form.Item label="고객사명" required>
              <Input
                name="name"
                placeholder="고객사명"
                value={customer.name}
                onChange={handleChange}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Form.Item label="상태" required>
              <Select
                value={customer.status}
                onChange={(value) => setCustomer({ ...customer, status: value })}
                options={[
                  { value: 'ACTIVE', label: '활성' },
                  { value: 'INACTIVE', label: '비활성' },
                ]}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Form.Item label="대표 연락처">
              <Input
                name="tel"
                placeholder="대표 연락처"
                value={customer.tel}
                onChange={handleChange}
                style={{ width: 300 }}
              />
            </Form.Item>
            <Space align="center">
              <Form.Item label="주소">
                <Input
                  name="address"
                  placeholder="주소"
                  value={customer.address}
                  onChange={handleChange}
                  style={{ width: 300 }}
                />
              </Form.Item>
              <Form.Item label="상세주소">
                <Input
                  name="addressDetail"
                  placeholder="상세주소"
                  value={customer.addressDetail}
                  onChange={handleChange}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </Space>
          </Flex>
          <Divider orientation="left" orientationMargin={0} className={cx('divider')}>
            부가정보
          </Divider>
          <Row align="top" style={{ maxWidth: 640 }}>
            <Col span={12}>
              <Form.Item label="메모">
                <Input.TextArea
                  name="memo"
                  value={customer.memo}
                  onChange={handleChange}
                  placeholder="메모"
                  rows={5}
                  className={cx('textArea')}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Space direction="vertical">
                <Space.Compact>
                  <Form.Item label="등록자">
                    <Statistic value={customer.createdBy?.name} />
                  </Form.Item>
                  <Form.Item label="등록일시">
                    <Statistic value={dayjs(customer.createdAt).format('YYYY-MM-DD HH:mm:ss')} />
                  </Form.Item>
                </Space.Compact>
                <Space.Compact>
                  <Form.Item label="수정자">
                    <Statistic value={customer.updatedBy?.name} />
                  </Form.Item>
                  <Form.Item label="수정일시">
                    <Statistic value={dayjs(customer.updatedAt).format('YYYY-MM-DD HH:mm:ss')} />
                  </Form.Item>
                </Space.Compact>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
      <Row align="middle" justify="space-between">
        <Space>
          <Button onClick={() => navigate(-1)}>뒤로</Button>
          <Button danger type="primary" onClick={doRemove}>
            삭제
          </Button>
        </Space>
        <Button type="primary" onClick={doSave}>
          저장
        </Button>
      </Row>
    </div>
  );
};

export default Page;
